<template>
  <div class="choose-page">
    <div class="cell-box">
      <div class="left"><span style="color:#f56c6c">*</span>仓库</div>
      <div class="right" @click="stashPicker = true">
        <span :class="{ 'is-error': isError && !stashName }" v-if="!stashName">请选择</span>
        <span class="value-font" v-else>{{ stashName }}</span>
        <i class="iconfont icon-a-xialakaobei"></i>
      </div>
    </div>
    <div class="cell-box">
      <div class="left"><span style="color:#f56c6c">*</span>数量(件)</div>
      <van-field v-model="goodSum" label="" :error="isError && !goodSum" type="number" placeholder="请输入"
        input-align="right" />
    </div>
    <div class="cell-box">
      <div class="left"><span style="color:#f56c6c">*</span>开船时间</div>
      <div class="right" @click="timePicker = true">
        <span :class="{ 'is-error': isError && !timePicker }" v-if="!shipTime">请选择</span>
        <span class="value-font" v-else>{{ shipTime | dateFormat('yyyy/MM/dd') }}</span>
        <i class="iconfont icon-a-xialakaobei"></i>
      </div>
    </div>
    <van-popup v-model="stashPicker" round position="bottom">
      <van-picker ref="stashPicker" :title="'选择仓库'" value-key="text" show-toolbar v-model="stashValue"
        :columns="stashList" @cancel="stashPicker = false" @confirm="stashConfirm" />
    </van-popup>
    <van-popup v-model="timePicker" round position="bottom">
      <van-datetime-picker v-model="shipTime" @confirm="timeConfirm" @cancel="timePicker = false" type="date"
        title="选择开船时间" :formatter="formatter" :min-date="minDate" />
    </van-popup>
    <div class="fontBut">
      <div class="but" @click="delStash">删除</div>
      <div class="but solid-but" @click="handleSave">保存</div>
    </div>
  </div>
</template>

<script>
import { Dialog } from 'vant';
import { sampleApi } from '../api/lookApi/api'
import { mapMutations } from "vuex";
const pageApi = new sampleApi()
export default {
  name: 'ViewingSamplePhoneChooseStash',

  data() {
    let getDefaultDate = () => {
      let date = new Date();
      date.setDate(date.getDate() + 100);
      let year = date.getFullYear();
      let month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      return year + "-" + month + "-" + day;
    }
    return {
      stashPicker: false,
      timePicker: false,
      stashName: '',
      stashValue: '',
      countryId: '',
      codeId: '',
      shipTime: getDefaultDate(),
      goodSum: '',
      stashList: [],
      minDate: new Date(),
      errorList: [],
      isBack: true,
      isError: false,
      countryTypeName: null
    };
  },
  computed: {
    route() {
      return this.$route.query
    },

  },
  async mounted() {
    if (this.$route.query.code) {
      let code = JSON.parse(this.$route.query.code)
      this.goodSum = code.goodSum
      this.shipTime = code.shipTime
      this.codeId = code.codeId
      this.stashName = code.code
      this.countryId = code.countryId;
    }
    this.countryTypeName = this.$route.query.countryTypeName;
    await this.getStashList()
    if (this.$route.query.codes) {
      let codes = JSON.parse(this.$route.query.codes);
      this.stashList.forEach((stash) => {
        if (codes.indexOf(stash.codeId) != -1) {
          stash.disabled = true
        }
      })
    }
  },
  // beforeRouteLeave(to, from, next) {
  //   if (this.isBack) {
  //     this.isBack = false,
  //       this.$router.replace({
  //         path: this.route.type == 'advice' ? 'SampleImg' : "DecisionImg",
  //         query: {
  //           proofId: this.route.proofId,
  //           userId: this.route.userId,
  //         }
  //       })
  //   } else {
  //     next()
  //   }
  // },
  methods: {
    ...mapMutations(["setStash"]),
    async getStashList() {
      let _list = []; let obj = {};
      const list = await pageApi.getStashList();
      let cList = [];
      if (this.countryId) {
        list.forEach((item) => {
          if (item.countryId === this.countryId) {
            cList.push(item);
          }
        });
      } else if (this.countryTypeName) {
        list.forEach((item) => {
          if (item.countryTypeName === this.countryTypeName) {
            cList.push(item);
          }
        });
        
      }


      cList.forEach(item => {
        obj = {
          text: item.countryTypeName,
          countryId: item.countryId,
          // children: [
          // ]
        }
        if (!item.codeList) {
          item.codeList = []
        }
        item.codeList.forEach(code => {
          // obj.children.push()
          _list.push({ text: code.code, codeId: code.codeId, countryId: code.countryId, disabled: false })
        })
        // _list.push(obj)
      });
      this.stashList = JSON.parse(JSON.stringify(_list))
    },
    stashConfirm(val, key) {
      if (!this.$refs.stashPicker.getValues()[0].disabled) {
        this.stashName = val.text;
        this.stashPicker = false;
        this.stashList.forEach((ct, ctIndex) => {
          if (key == ctIndex) {
            this.codeId = ct.codeId
            this.countryId = ct.countryId
          }
          //   
          //   ct.children.forEach((code, index) => {
          //     if (key[1] == index) {
          //       this.codeId = code.codeId
          //     }
          //   })
          // }
        })
      }

    },
    handleSave() {
      if (!this.stashName || !this.shipTime || !this.goodSum) {
        this.isError = true
      } else {
        this.isError = false
      }
      let stashInfo = {
        proofId: this.route.proofId,
        userId: this.route.userId,
        stashName: this.stashName,
        countryId: this.countryId,
        codeId: this.codeId,
        shipTime: this.shipTime,
        goodSum: this.goodSum
      }
      if (!this.isError) {
        this.setStash(stashInfo)
        this.isBack = false
        this.$router.back()
        // this.$router.replace({
        //   path: this.route.type == 'advice' ? 'SampleImg' : "DecisionImg",
        //   query: {
        //     proofId: this.route.proofId,
        //     userId: this.route.userId,
        //     stashName: this.stashName,
        //     countryId: this.countryId,
        //     codeId: this.codeId,
        //     shipTime: this.shipTime,
        //     goodSum: this.goodSum
        //   }
        // })

      }
    },
    delStash() {
      Dialog.confirm({
        title: '提示',
        message: '是否确认删除该仓库?',
        confirmButtonColor: "#3F996C",
      }).then(() => {
        let stashInfo = {
          isDel: 1
        }
        this.setStash(stashInfo)
        this.isBack = false
        this.$router.back()
        // this.$router.push({
        //   path: this.route.type == 'advice' ? 'SampleImg' : "DecisionImg",
        //   query: {
        //     proofId: this.route.proofId,
        //     userId: this.route.userId,
        //     isDel: 1
        //   }
        // })
      }).catch(() => {
      })
    },
    timeConfirm(date) {
      let year = date.getFullYear();
      let month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      this.shipTime = year + "-" + month + "-" + day;
      this.timePicker = false
    },
    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`;
      } else if (type === 'month') {
        return `${val}月`;
      } else if (type == 'day') {
        return `${val}日`
      }
      return val;
    },

  },
};
</script>

<style lang="scss" scoped>
.choose-page {
  padding: 30px;
  height: 85vh;
  background: #f7f7f7;

  .cell-box {
    display: flex;
    justify-content: space-between;
    background: #fff;
    height: 92px;
    align-items: center;
    border-radius: 22px;
    padding: 0 20px;
    margin-bottom: 30px;

    .left {
      flex-shrink: 0;
      font-size: 32px;
      color: #606266;
    }

    .right {
      display: flex;
      align-items: center;
      font-size: 32px;

      >span {
        color: #909399;
      }

      .is-error {
        color: #f56c6c;
      }

      .value-font {
        color: #303133;
      }

      .icon-a-xialakaobei {
        color: #909399;
        margin-left: 5px;
        transform: rotate(90deg);
        transform-origin: center;
        display: inline-block;
        font-size: 16px;
        scale: 0.7;
      }
    }
  }
}
</style>